import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Biochemistry = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.76 12.568a.79.79 0 0 0-1.106 0c-1.306 1.405-2.914 2.007-4.522 2.207l-8.944-8.93c.2-1.706.904-3.211 2.21-4.515a.787.787 0 0 0 0-1.104.79.79 0 0 0-1.105 0c-3.718 3.712-3.014 8.529-1.91 13.145-11.556-3.512-18.69 3.612-15.073 15.05-2.412-.601-5.025-1.103-7.437-.802-1.306 0-6.833 1.806-5.728 3.813a.79.79 0 0 0 1.106 0c1.306-1.405 2.914-2.007 4.522-2.207l8.944 8.93c-.201 1.706-.905 3.211-2.211 4.515a.786.786 0 0 0 0 1.104.79.79 0 0 0 1.105 0c3.719-3.712 2.915-8.63 1.91-13.245 2.01.502 4.02.903 6.03.903h.1c8.843.2 11.557-8.63 9.044-15.954 4.623 1.103 9.547 1.806 13.165-1.907.2-.2.2-.702-.1-1.003ZM7.882 29.225c1.81.1 3.718.501 5.728 1.003.503 2.007.905 3.913 1.005 5.72l-6.733-6.723Zm7.135-.402a35.907 35.907 0 0 1-.904-4.515l5.427 5.418c-1.508-.1-3.015-.501-4.523-.903Zm6.934 1.104-8.04-8.027c0-1.806.503-3.512 1.81-4.917L26.877 28.12c-1.508 1.304-3.116 1.706-4.925 1.806Zm6.03-2.91L16.827 15.88c1.206-1.003 2.613-1.505 4.12-1.706l8.844 8.83c-.201 1.405-.704 2.81-1.81 4.014Zm-4.824-12.844c1.709.1 3.618.502 5.527 1.004.503 1.906.905 3.813 1.005 5.519l-6.532-6.523Zm6.934-.401c-.502-2.007-.904-3.913-1.005-5.72l6.733 6.723c-1.809-.1-3.718-.501-5.728-1.003Z"
  }));
});
Biochemistry.displayName = 'Biochemistry';
Biochemistry.defaultProps = {
  'aria-label': 'Biochemistry'
};
export default Biochemistry;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Biochemistry.js
// module id = 2983
// module chunks = 11